/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_TomorrowInputs */

const en_plan_tomorrow = /** @type {(inputs: Plan_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tomorrow`)
};

const de_plan_tomorrow = /** @type {(inputs: Plan_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Morgen`)
};

/**
* | output |
* | --- |
* | "Tomorrow" |
*
* @param {Plan_TomorrowInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tomorrow = /** @type {((inputs?: Plan_TomorrowInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_TomorrowInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_plan_tomorrow(inputs)
	return en_plan_tomorrow(inputs)
});